import { Package } from "typings/microserviceModels/packaging-flex-module";
import * as React from "react";
import { UitkText } from "uitk-react-text";

export const AddressAndNeighborhood = ({ packageItem }: { packageItem: Package }): React.ReactElement | null => {
  if (!packageItem.showNeighborhood || !packageItem.hotelAddress) return null;

  return <UitkText size={300}>{packageItem.hotelAddress.hotelNeighborhood}</UitkText>;
};
